import { useUser } from "~config/user-provider"
import { usePreCheckoutDataQuery } from "~graphql/generated/graphql"

export default function usePreCheckoutData(outfitterId: string) {
    const { user } = useUser()

    const {
        data,
        loading: isLoading,
        error,
    } = usePreCheckoutDataQuery({ variables: { outfitterId }, skip: !user })

    const isAchAvailable = data?.preCheckoutData.is_ach_available ?? false

    return { isAchAvailable, isLoading, error }
}
